import React, { useState } from 'react'
import './Contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { FaTelegram, FaGooglePlay } from 'react-icons/fa'

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(''); // 'sending' | 'success' | 'error' | ''

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    // Build mailto link with form data
    const subject = encodeURIComponent(`Portfolio Contact from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    );
    const mailtoLink = `mailto:contact@notragnar.com?subject=${subject}&body=${body}`;

    // Open email client
    window.location.href = mailtoLink;

    // Show success state
    setTimeout(() => {
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setStatus(''), 4000);
    }, 1000);
  };

  return (
    <section id='contact'>
      <div className="section__wrapper contact__container">
        <div className="section__header center">
          <h2 className='primary__title'>Get In Touch</h2>
          <p className="text__muted description">
            Have a project idea, question, or just want to say hello? Reach out through any of these channels.
          </p>
        </div>

        <div className="contact__group">
          <div className="contact__options">
            <article className="contact__option">
              <MdOutlineEmail className='contact__icon' />
              <h3>Email</h3>
              <h5 className="text__muted">contact@notragnar.com</h5>
              <a href="mailto:contact@notragnar.com" target='_blank' rel='noreferrer' className='btn btn__primary'>Send Email</a>
            </article>

            <article className="contact__option">
              <FaTelegram className='contact__icon' />
              <h3>Telegram</h3>
              <h5 className="text__muted">@Not_Ragnar</h5>
              <a href="https://telegram.me/Not_Ragnar" target='_blank' rel='noreferrer' className='btn btn__primary'>Message Me</a>
            </article>

            <article className="contact__option">
              <FaGooglePlay className='contact__icon' />
              <h3>Play Store</h3>
              <h5 className="text__muted">Ragnar Servers</h5>
              <a href="https://play.google.com/store/apps/developer?id=Ragnar+Servers" target='_blank' rel='noreferrer' className='btn btn__primary'>View Apps</a>
            </article>
          </div>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name='name'
              placeholder='Your Full Name'
              required
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name='email'
              placeholder='Your Email'
              required
              value={formData.email}
              onChange={handleChange}
            />
            <textarea
              name="message"
              rows="7"
              placeholder='Your Message'
              required
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            <button
              type='submit'
              className='btn btn__primary'
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Opening Email Client...' : 'Send Message'}
            </button>
            {status === 'success' && (
              <p className="form__status form__status--success">
                ✅ Email client opened! Please hit send in your email app.
              </p>
            )}
            {status === 'error' && (
              <p className="form__status form__status--error">
                ❌ Something went wrong. Please try again or use the contact options above.
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact

